import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findDeviceContract } from 'actions/deviceContracts';
import { findAttSub } from 'actions/attSubs';
import { findSub } from 'actions/subs';
import { findPurchase } from 'actions/purchases';
import { getDeviceContract, getSub, getAttSub, getPurchase } from 'reducers';
import withDeviceContract from './withDeviceContract';

const deviceContractPage = (DecoratedComponent) => {
  class DeviceContractPage extends Component {
    componentDidMount() {
      const { deviceContract } = this.props;
      if (deviceContract) {
        this.fetchAdditionalData();
      } else {
        this.fetchContractInfo();
      }
    }

    componentDidUpdate(oldProps) {
      if (this.props.deviceContractId !== oldProps.deviceContractId) {
        this.fetchContractInfo();
      }

      const { deviceContract } = this.props;
      const oldDeviceContract = oldProps.deviceContract;
      if (
        (deviceContract && !oldDeviceContract) ||
        (deviceContract &&
          oldDeviceContract &&
          deviceContract.id !== oldDeviceContract.id)
      ) {
        this.fetchAdditionalData();
      }
    }

    fetchContractInfo() {
      const { findDeviceContract, deviceContractId } = this.props;
      findDeviceContract(deviceContractId);
    }

    fetchAdditionalData() {
      const { deviceContract, findSub, findAttSub, findPurchase } = this.props;
      if (deviceContract) {
        const { subscription, att_subscription, purchase } = deviceContract;
        subscription && findSub(subscription);
        att_subscription && findAttSub(att_subscription);
        purchase && findPurchase(purchase);
      }
    }

    render() {
      const { children, ...props } = this.props;
      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapDispatchToProps = {
    findDeviceContract,
    findSub,
    findAttSub,
    findPurchase,
  };

  const mapStateToProps = (state, ownProps) => {
    const deviceContract = getDeviceContract(state, ownProps.deviceContractId);
    const subscription = deviceContract && deviceContract.subscription;
    const attSubscription = deviceContract && deviceContract.att_subscription;
    const purchase = deviceContract && deviceContract.purchase;

    return {
      deviceContract,
      sub: subscription ? getSub(state, subscription) : null,
      attSub: attSubscription ? getAttSub(state, attSubscription) : null,
      purchase: purchase ? getPurchase(state, purchase) : null,
    };
  };

  DeviceContractPage = withDeviceContract(
    connect(mapStateToProps, mapDispatchToProps)(DeviceContractPage),
  );

  return DeviceContractPage;
};

export default deviceContractPage;
